import { change } from 'redux-form'
import {
  updateReshipmentItem,
  cancelNewMaterial,
  selectNewMaterial,
  finishedAddingNewMaterial,
} from '../../actions/reshipment'
import { Text, Select, Button } from '../common'
import {
  RESHIPMENT_FORM_NAME,
  RESHIPMENT_QTY_FIELD,
  RESHIPMENT_NEW_MATERIAL,
} from '../../constants/ReshipmentConstants'
import {
  getReshipmentSummaryData,
  getReshipmentSavingStatusProps,
  getReshipmentSavingData,
  getNonSecureMaterials,
} from '../../selectors/reshipment'

const mapStateToProps = (state, ownProps) => {
  const {
    data: {
      name,
      description,
      examDateType,
      ancillaryCd,
      quantity,
      isNewItem = false,
      isNonSecure,
      [RESHIPMENT_QTY_FIELD]: reshipQuantity,
    },
    breakpoint,
  } = ownProps
  const { orgId, addingMaterial, data: summaryData } = getReshipmentSummaryData(state)
  const { saving } = getReshipmentSavingStatusProps(state)
  const { data: savedReshipmentData = {} } = getReshipmentSavingData(state)
  const {
    data: { [examDateType]: allNonSecureItems = [] },
  } = getNonSecureMaterials(state)
  // Create a list of all items in summary
  const summaryAncillaryCds =
    Object.keys(summaryData).length > 0 &&
    summaryData[examDateType] &&
    summaryData[examDateType].result.length > 0
      ? summaryData[examDateType].result
      : []
  // Filter nonSecureItems by any items currently added in this test window
  const nonSecureItems = allNonSecureItems.filter(
    item => !summaryAncillaryCds.includes(item.ancillaryCd)
  )
  const qtyFieldName = `${examDateType}.${ancillaryCd}.${RESHIPMENT_QTY_FIELD}`
  const savedQuantity =
    savedReshipmentData[examDateType]?.find(item => item.ancillaryCd === ancillaryCd)?.quantity || 0
  return {
    orgId,
    name,
    description,
    ancillaryCd,
    quantity,
    reshipQuantity,
    qtyFieldName,
    examDateType,
    breakpoint,
    isPristine: reshipQuantity === savedQuantity,
    savedQuantity,
    saving,
    nonSecureItems,
    addingMaterial,
    isNewItem,
    isNonSecure,
  }
}

export default connect(mapStateToProps, {
  updateReshipmentItem,
  cancelNewMaterial,
  selectNewMaterial,
  finishedAddingNewMaterial,
  change,
})(
  ({
    orgId,
    name,
    description,
    ancillaryCd,
    quantity,
    reshipQuantity,
    qtyFieldName,
    examDateType,
    isPristine,
    savedQuantity,
    saving,
    nonSecureItems,
    addingMaterial,
    isNewItem,
    isNonSecure,
    breakpoint,
    updateReshipmentItem,
    cancelNewMaterial,
    selectNewMaterial,
    finishedAddingNewMaterial,
    change,
  }) => {
    let containerWidth = {}
    switch (breakpoint) {
      case 'mobile':
        containerWidth = { width: '160px' }
        break

      case 'tablet':
        containerWidth = { width: '170px' }
        break

      case 'desktop':
        containerWidth = { width: '300px' }
        break

      default:
        containerWidth = { width: '450px' }
    }

    // There's a brief moment between when we add stubbed data for a non-secure
    // item and when the form data re-initializes with the new data and in that
    // space we want to skip rendering the ReshipmentItem
    if (!examDateType) return null

    return (
      <div
        style={{
          border: '1px solid #ccc',
          padding: '15px',
          marginBottom: '10px',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div style={{ flexWrap: 'wrap', ...containerWidth }}>
            {isNewItem && !name ? (
              <Select
                name={RESHIPMENT_NEW_MATERIAL}
                label="Select Material"
                autoFocus={true}
                onChange={e => {
                  const { value } = e.target
                  const name = e.target.options[e.target.selectedIndex].innerHTML
                  if (value !== '') {
                    selectNewMaterial({ name, ancillaryCd: value, examDateType })
                  }
                }}
                options={nonSecureItems.map(item => ({
                  value: item.ancillaryCd,
                  label: item.description,
                }))}
                style={{ marginBottom: 0 }}
              />
            ) : (
              <div className="reshipment-item-name" style={{ fontWeight: 'bold' }}>
                {name}
              </div>
            )}
            {description && <div>{description}</div>}
            {!isNonSecure && quantity !== null && <div>Qty: {quantity}</div>}
          </div>
          <div style={{ display: 'inline-block', flexWrap: 'nowrap', marginLeft: 'auto' }}>
            <Text
              name={qtyFieldName}
              input={{
                name: qtyFieldName,
                value: reshipQuantity,
                onChange: e => {
                  const { value } = e.target
                  let setVal = null
                  if (value === '') {
                    setVal = ''
                  } else if (value === '0') {
                    setVal = 0
                  } else {
                    const testVal = parseInt(value, 10)
                    if (!Number.isNaN(testVal)) {
                      setVal = testVal
                    }
                  }
                  if (setVal !== null) {
                    change(RESHIPMENT_FORM_NAME, qtyFieldName, setVal)
                  }
                },
              }}
              label={isNewItem || isNonSecure ? 'Qty' : 'Reship'}
              maxlength={4}
              inputStyle={{ display: 'inline-block', margin: '0 15px', width: '5em' }}
              formGroupStyle={{ display: 'inline-block', marginBottom: 0 }}
              placeholder="Qty"
              autocomplete="off"
              disabled={!name}
            />
            <Button
              isDisabled={isPristine || saving}
              onClick={() => {
                updateReshipmentItem(orgId, { ancillaryCd, quantity: reshipQuantity })
                if (isNewItem) {
                  finishedAddingNewMaterial({ ancillaryCd, examDateType })
                }
              }}
              style={{ width: '8em' }}
            >
              {savedQuantity === 0 ? 'Add' : 'Update'}
            </Button>
          </div>
        </div>
        {isNewItem && addingMaterial && (
          <div style={{ textAlign: 'right' }}>
            <Button
              onClick={() => cancelNewMaterial(examDateType, ancillaryCd)}
              style={{ width: '8em', marginTop: '8px' }}
            >
              Cancel
            </Button>
          </div>
        )}
      </div>
    )
  }
)
